import React, { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer } from "recharts";

const SalesBarChart = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/monthly-sales-summary/`)
      .then((res) => res.json())
      .then((data) => {
        setData(data);
      });
  }, []);

  return (
    <div className="card- p-3 shadow">
      <h5 className="text-primary">Monthly Sales</h5>
      <ResponsiveContainer height={300} width="100%">
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis />
          <Tooltip/>
          <Bar dataKey="sales" fill="#0acfc2ff"/>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SalesBarChart;
